import React from "react"
import { Routes, Route } from "react-router-dom"

import { authProtectedRoutes, publicRoutes } from "./routes"
import Authmiddleware from "./routes/middleware"

import Layout from "./components/layout/main.layout"
import PublicLayout from "./components/layout/public.layout"

import './assets/scss/app.scss'

const App = (props) => {

  const documentHeight = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  window.addEventListener('resize', documentHeight)
  documentHeight()

  return (
    <React.Fragment>
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route key={idx} exact path={route.path} element={<Authmiddleware isAuthProtected={false} />} >
            <Route exact path={route.path} element={
              <PublicLayout>
                <route.component {...props} />
              </PublicLayout>
            } />
          </Route>
        ))}

        {authProtectedRoutes.map((route, idx) => (
          <Route key={idx} exact path={route.path} element={<Authmiddleware isAuthProtected={true} />} >
            <Route exact path={route.path} element={
              <Layout>
                <route.component {...props} />
              </Layout>
            } />
          </Route>
        ))}
      </Routes>
    </React.Fragment>
  );
};

export default App;
